// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"8b6ebecc","127":"75785c98","205":"97692eae","259":"306b234c","386":"49aa41c7","419":"8290ca4f","518":"38b3135a","660":"64d78583","661":"7537060c","768":"8f7bd85e","858":"9cd9d0af","938":"2b9f83d0"}[chunkId] + ".chunk.js";
};